module.exports = __webpack_public_path__ + "static/introduction-6ecdec57e2eb0a6f05db37279accc21e.mp4";